import styled from 'styled-components';
import { SecondaryColorsProps } from '../../../styles/theme/color';
import { Popover } from '../../molecules/Popover/index';

export const StyledTag = styled.div<{ color: SecondaryColorsProps }>`
  display: flex;
  justify-content: center;
  background-color: ${(props) => props.theme.colors.secondary[props.color]};
  border-radius: ${(props) => props.theme.radius['3px']};
`;

export const Label = styled.span`
  display: block;
  font-size: 0.9rem;
  color: ${(props) => props.theme.colors.primary.white};
  padding: ${(props) => props.theme.spacing['4px']}
    ${(props) => props.theme.spacing['8px']};
`;

export const InfoComponentWrapper = styled.div`
  background-color: rgba(34, 34, 34, 0.33);
  height: 25px;
  width: 25px;
  border-top-right-radius: ${(props) => props.theme.radius['3px']};
  border-bottom-right-radius: ${(props) => props.theme.radius['3px']};
  padding: 0.25rem;
  margin-left: 0.25rem;
  cursor: pointer;

  > svg {
    fill: ${(props) => props.theme.colors.primary.white};
  }
`;

export const StyledPopover = styled(Popover)`
  & .card {
    width: 15rem;
    top: 40px;
    font-size: 14px;
  }

  & .content {
    padding: 0 1rem;
  }
`;
